var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPublishBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 198,
    height: 60.337,
    viewBox: "0 0 198 60.337",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#2636b0;}.c{fill:#ffb800;}.d{font-size:19.523px;font-family:Futura-CondensedExtraBold, Futura;font-weight:800;letter-spacing:0.05em;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1543.04 -1160.661)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1543.04 1160.661)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1542 -1188)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 182.183,
    height: 44.521,
    transform: "translate(1542.586 1188.586)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1725.355,1233.692H1542V1188h183.355Zm-182.183-1.171h181.011v-43.349H1543.172Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1542 -1188)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1724.769,1233.107v-44.521l14.645,14.645v44.52H1557.231l-14.645-14.644Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1739.414,1248.337H1557.231l-.414-.171-14.645-14.645.414-1h181.6v-43.935l1-.414,14.645,14.645.172.414v44.52Zm-181.941-1.171h181.355v-43.693L1725.355,1190v43.107l-.586.585H1544Z"
  }))), /*#__PURE__*/React.createElement("text", {
    className: "d",
    transform: "translate(1601.044 1191.117)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Publish")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublishBtn);
export default __webpack_public_path__ + "static/media/publishBtn.05c87119a5d57ce5f635b73072bfe4a5.svg";
export { ForwardRef as ReactComponent };